import { render, staticRenderFns } from "./ReportsView.vue?vue&type=template&id=16806e5a&scoped=true"
import script from "./ReportsView.vue?vue&type=script&lang=ts"
export * from "./ReportsView.vue?vue&type=script&lang=ts"
import style0 from "./ReportsView.vue?vue&type=style&index=0&id=16806e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16806e5a",
  null
  
)

export default component.exports